import request from '@/utils/request'
//get
export function getDongleSaleParam(param) {
    return request({
        url: `/dongle_sale/${param}`,
        method: 'GET'
    })
}

export function buyPrice(data) {
    return request({
        url: `/dongle_sale/buy_price/`,
        method: 'POST',
        data
    })
}

export function buy(data) {
    return request({
        url: `/dongle_sale/buy/`,
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/dongleSale.js